import { client } from "./_base";

const endpoint = "palletbase";
export const palletbase = client(endpoint, (item) => ({
  ...item,
}));
